(ns sci.impl.unrestrict
  {:no-doc true})

(def ^:dynamic *unrestricted* false)
